import { Component, NgModule, OnInit } from '@angular/core';
import { JobCardComponentModule } from '@component/generic/cards/job-card/job-card.component';
import { ImageSliderComponentModule } from '@component/generic/image-slider/image-slider.component';
import { Job } from '@model/entities/job';
import { CareersService } from '@service/careers.service';
import { LoadingService } from '@service/loading.service';
import { MobileService } from '@service/mobile.service';
import { SliderImagesService } from '@service/slider-images.service';
import { ToastService } from '@service/toast/toast.service';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {
  public hasSliderImages: boolean = false;
  public careers: Job[] = null

  constructor(
    public mobileService: MobileService,
    public sliderImagesService: SliderImagesService,
    public careerService: CareersService,
    public loadingService: LoadingService,
    public toasService: ToastService,
  ) { }

  ngOnInit() {
    this.getEntities();

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('career');
  }

  public getEntities(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loadingService.startLoad()

      this.careerService
        .getAll()
        .then((careers) => {
          this.careers = careers
        })
        .catch(() => {
          this.toasService.showError('Karriere konnte nicht abgerufen werden.')
        })
        .finally(() => {
          this.loadingService.stopLoad()
          resolve()
        })
    })
  }

}

@NgModule({
  declarations: [
    CareerComponent
  ],
  imports: [
    SharedModule,
    ImageSliderComponentModule,
    JobCardComponentModule,
  ],
  exports: [
    JobCardComponentModule,
    CareerComponent,
  ]
})

export class CareerComponentModule { }